import React, { useState } from "react";
import Header from './Header';
import Creategooglekeep from "./Creategooglekeep";
import Googlekeppin from "./Googlekeppin";
import Footer from './Footer';


const Googlekeep = () => {
  const [addItem, setAddItem] = useState([]);
  const addNote = (note) => {
    setAddItem((prevData) => {
      return [...prevData, note];
    })
    //console.log(note);
  }
  const onDelete = (id) =>{
    setAddItem((olddata) =>{
      return (
        olddata.filter((currdate , indx) => {
          return indx !== id;
        })
      )
    })
  }
  return (
    <><div>
      <Header />
      <Creategooglekeep passNote={addNote} />
      <div className="row mt-4">

      {addItem.map((val, index)=>{
        return (<Googlekeppin
        key={index} id={index} title={val.title} content={val.content} deleteItem={onDelete}
      />)})
       } </div>
      <Footer />
    </div>
    </>
  );

};

export default Googlekeep;
